import { FC, ReactNode } from "react";
import Card from "../Layout/Card";
import { ButtonIcon } from "../UI/Buttons";
import useIsMobile from "@/custom_hooks/isMobile";

type Props = {
    handleSubmit: React.FormEventHandler<HTMLFormElement>,
    isLoading: boolean,
    onChange: React.ChangeEventHandler<HTMLInputElement>,
    name: string,
    email: string,
    successMsg?: string,
    errorMsg?: string,
    checkbox: ReactNode,
}

const inputClasses = `
    bg-transparent
    inline-flex h-[53px] w-full items-center justify-center 
    rounded-[10px] 
    px-[10px] 
    text-[18px] leading-none 
    shadow-grey-400 md:shadow-stroke shadow-[0_0_0_1px] outline-none focus:shadow-[0_0_0_2px]
`

const MinimalNewsletterForm: FC<Props> = ({
    handleSubmit,
    onChange,
    isLoading,
    name,
    email,
    successMsg,
    errorMsg,
    checkbox
}) => {

    const isMobile = useIsMobile();

    return (
        <Card theme="dark" padding="50/40" className="max-w-[765px]">

   {/* <div className="grid relative md:grid-cols-2 gap-4 bg-grey-200
            px-4 py-10 md:pl-[93px] md:pt-[50px] md:pb-[20px] 
            border-[1px] border-stroke rounded-[22px] overflow-hidden"
        > */}
                <form onSubmit={handleSubmit} >
                    <h2 className="mb-[30px]">Norite būti informuotas apie studijos rezultatus?</h2>
                    <div className="flex flex-col mb-[30px]">
                        <div className="flex flex-col mb-4 gap-2">
                        <label
                            className="md:text-lg"
                            htmlFor="full_name"
                        >
                            Vardas ir pavardė*
                        </label>
                        <input
                            className={inputClasses}
                            id="full_name"
                            disabled={isLoading}
                            name="full_name"
                            value={name}
                            onChange={onChange}
                        />
                        </div>

                        <div className="flex flex-col gap-2">
                        <label
                            className="md:text-lg"
                            htmlFor="email"
                        >
                            El. paštas*
                        </label>
                        <input
                            className={inputClasses}
                            id="email"
                            disabled={isLoading}
                            name="email"
                            value={email}
                            onChange={onChange}
                        />
                        </div>
                        {checkbox}
                    </div>
                    {
                        (successMsg || errorMsg) && 
                        <div className="flex justify-center mb-[30px]">
                            {successMsg && !errorMsg &&
                                <p className="text-green-700">
                                    {successMsg}
                                </p>
                            }
                            {errorMsg && !successMsg && (
                                <p className="text-red-700">
                                    {errorMsg}
                                </p>
                            )}
                        </div>
                    }
                    

                    <div className="flex w-full justify-center">
                        <ButtonIcon disabled={isLoading} submitType={true} iconWidth={isMobile ? 19 : 24} iconHeight={isMobile ? 19 : 24} label="Registruotis" icon="email" theme="light" />
                    </div>
                </form>
        {/* </div> */}
        </Card>
    )
}

export default MinimalNewsletterForm;